export enum DeletionState {
    Ready,
    DeletingPreparing,
    Deleting,
    DeletingSuccessful,
    Deleted,
}